import {
  Dispatch,
  FC,
  ReactNode,
  SetStateAction,
  createContext,
  useState,
} from 'react';

export interface ExperienceContextProps {
  inShortList: boolean;
  handleShortList: (inShortList: boolean) => void;
  enquiryDate: { start: Date | null; end: Date | null };
  setEnquiryDate: Dispatch<
    SetStateAction<{ start: Date | null; end: Date | null }>
  >;
  enquiryAdultsTotal: number;
  setEnquiryAdultsTotal: Dispatch<SetStateAction<number>>;
  enquiryInfantsTotal: number;
  setEnquiryInfantsTotal: Dispatch<SetStateAction<number>>;
  enquiryChildrenTotal: number;
  setEnquiryChildrenTotal: Dispatch<SetStateAction<number>>;
}

interface ExperienceProviderProps {
  children: ReactNode;
}

const ExperienceContext = createContext<ExperienceContextProps>(
  {} as ExperienceContextProps,
);

export const ExperienceContextProvider: FC<ExperienceProviderProps> = ({
  children,
}) => {
  const [inShortList, setInShortList] = useState(false);
  const [enquiryDate, setEnquiryDate] = useState<{
    start: Date | null;
    end: Date | null;
  }>({
    start: null,
    end: null,
  });
  const [enquiryAdultsTotal, setEnquiryAdultsTotal] = useState(0);
  const [enquiryInfantsTotal, setEnquiryInfantsTotal] = useState(0);
  const [enquiryChildrenTotal, setEnquiryChildrenTotal] = useState(0);

  function handleShortList(inShortList: boolean) {
    setInShortList(inShortList);
  }

  return (
    <ExperienceContext.Provider
      value={{
        inShortList,
        handleShortList,
        enquiryDate,
        setEnquiryDate,
        enquiryAdultsTotal,
        setEnquiryAdultsTotal,
        enquiryInfantsTotal,
        setEnquiryInfantsTotal,
        enquiryChildrenTotal,
        setEnquiryChildrenTotal,
      }}>
      {children}
    </ExperienceContext.Provider>
  );
};

export default ExperienceContext;
